import angular from 'angular'
import manageSchoolsDir from './manage_schools'
import manageAdminsDir from './manage_admins'
import manageDomainsDir from './manage_domains'
import editDomainEntity from './edit_domain_entity'
import editDomainInfoRec from './edit_domain_info_record'
import domainsService from './domains_service'
import domainListDir from './domain_list'
import domainInfoService from './domain_info_service'
import domainDetailDir from './domain_detail'
import schoolTable from './school_table'
import editSchoolEntity from './edit_school_entity'
import createSchoolEntity from './create_school_entity'
import createDomainEntity from './create_domain_entity'
import UseCodesDomainReport from './UseCodesDomainReport.vue'
import SignupLinks from './signup_links/SignupLinks.vue'
import Autoprovisioning from './autoprovisioning/Autoprovisioning.vue'
import AutoprovisioningForm from './autoprovisioning/AutoprovisioningForm.vue'
import AutoprovisioningSchedule from './autoprovisioning/AutoprovisioningSchedule.vue'
import AutoprovisioningScheduleForm from './autoprovisioning/AutoprovisioningScheduleForm.vue'
import AutoprovisioningAlert from './autoprovisioning/AutoprovisioningAlert.vue'
import Subgroups from '@/admin_entities/subgroups/Subgroups.vue'
import ImportModal from './autoprovisioning/ImportModal.vue'
import MergeSchoolsButton from './schools/MergeSchoolsButton.vue'
import MergeSchoolsModal from './schools/MergeSchoolsModal.vue'
import { uniqueIdForSSOExternalId } from './sso_external_id'

export default angular
  .module('adminPanel.domains', [])
  .directive('domainDetail', domainDetailDir)
  .directive('manageSchools', manageSchoolsDir)
  .directive('manageAdmins', manageAdminsDir)
  .directive('manageDomains', manageDomainsDir)
  .directive('editDomainInfoRecord', editDomainInfoRec)
  .directive('editDomainEntity', editDomainEntity)
  .directive('domainList', domainListDir)
  .directive('schoolTable', schoolTable)
  .directive('editSchoolEntity', editSchoolEntity)
  .directive('createDomainEntity', createDomainEntity)
  .directive('createSchoolEntity', createSchoolEntity)
  .factory('domains', domainsService)
  .factory('domainInfo', domainInfoService)
  .constant('uniqueIdForSSOExternalId', uniqueIdForSSOExternalId)
  .value(UseCodesDomainReport.name, UseCodesDomainReport)
  .value(SignupLinks.name, SignupLinks)
  .value(Autoprovisioning.name, Autoprovisioning)
  .value(AutoprovisioningForm.name, AutoprovisioningForm)
  .value(AutoprovisioningSchedule.name, AutoprovisioningSchedule)
  .value(AutoprovisioningScheduleForm.name, AutoprovisioningScheduleForm)
  .value(AutoprovisioningAlert.name, AutoprovisioningAlert)
  .value(ImportModal.name, ImportModal)
  .value(Subgroups.name, Subgroups)
  .value(MergeSchoolsButton.name, MergeSchoolsButton)
  .value(MergeSchoolsModal.name, MergeSchoolsModal)
  .value('domainFlags', {
    multiyear: 'Grace Period',
    toolkit_analytics: 'Toolkit User List (obsolete)',
    upp: 'University Partnerships',
    teks: 'TEKS (obsolete)',
    edequals: 'Education Equals (ILPs ONLY)',
    selective_messaging: 'Selective Messaging (ILPs ONLY)',
    interactive_guides_on: 'Interactive Guides On',
    threads_review_step: 'Threads Review Step',
    no_threads: 'No Threads Access'
  })
  .factory('domainActions', [
    '$http',
    'configuration',
    function($http, config) {
      return {
      }
    }
  ])
